module.exports = __webpack_public_path__ + "static/media/solar_bell-bold.093d34ff.svg";